import React, {useContext, useEffect} from "react";
import ModalsContext from "common/ModalsContext";
import Shutdown from "views/Administration/Shutdown/component";
import Reboot from "views/Administration/Reboot/component";
import Diagnostic from "views/Administration/Diagnostic/component";
import About from "views/About";

function Modals() {
    const {modal, openModal, closeModal} = useContext(ModalsContext);

    useEffect(() => {
        const modalTriggers = ['shutdown', 'reboot', 'diagnostic'];

        const handler = (e) => {
            const type = e.currentTarget.id;

            if (modal) {
                closeModal();
            }
            openModal({ type });
        };

        modalTriggers.forEach(id => {
            $(`#${id}`).on('click', handler);
        });

        return () => {
            modalTriggers.forEach(id => $(`#${id}`).off('click', handler));
        };
    }, []);


    if(!modal){
        return null;
    }

    const {type } = modal;

    if (type==="shutdown"){
        return <Shutdown />
    }

    if (type==="reboot"){
        return <Reboot />
    }

    if (type==="diagnostic"){
        return <Diagnostic />
    }

    if(type === "about") {
        return <About />
    }

    return null;
}

export default Modals;